import { designToken, quickProperty } from '../component-tokens';
export const borderBase = {
    'border-width': quickProperty('1px'),
    'border-style': quickProperty('solid'),
};
export const inputFieldBase = Object.assign(Object.assign({}, borderBase), { 'border-color': designToken('border'), color: designToken('text-01'), font: designToken('body-medium'), height: quickProperty('36px'), 'border-radius': quickProperty('4px') });
export const inputFieldHoverBase = {
    'border-color': designToken('border'),
};
export const smallInputFieldBase = {
    font: designToken('body-small'),
    height: quickProperty('30px'),
};
export const largeInputFieldBase = {
    height: quickProperty('42px'),
};
export const xLargeInputFieldBase = {
    height: quickProperty('48px'),
};
export const buttonBase = Object.assign(Object.assign({}, borderBase), { cursor: quickProperty('pointer'), 'box-sizing': quickProperty('border-box'), outline: quickProperty('none'), 'border-radius': quickProperty('4px'), 'white-space': quickProperty('normal') });
export const focusState = {
    'border-color': designToken('focus'),
    'box-shadow': designToken('highlight'),
};
export const inputFieldFocusBase = Object.assign(Object.assign({}, focusState), { 'box-shadow': designToken('highlight-small') });
export const primaryElementFocus = Object.assign({}, focusState);
export const secondaryElementFocus = Object.assign({}, focusState);
export const tertiaryElement = {
    color: designToken('link'),
    '--goto-icon-color': designToken('link'),
    'border-color': quickProperty('transparent'),
    'background-color': designToken('interactive-02'),
};
export const tertiaryNeutralElement = Object.assign(Object.assign({}, tertiaryElement), { color: designToken('text-01'), '--goto-icon-color': designToken('text-01') });
export const tertiaryElementHover = {
    'border-color': quickProperty('transparent'),
    'background-color': designToken('hover-secondary'),
};
export const tertiaryElementFocus = Object.assign({}, primaryElementFocus);
export const tertiaryElementActive = {
    'border-color': quickProperty('transparent'),
    'background-color': designToken('pressed-tertiary'),
    'box-shadow': quickProperty('none'),
};
